import React from 'react';
import Link from '../utils/link';
import LeftArrow from '../assets/images/left-arrow.svg';
import RightArrow from '../assets/images/right-arrow.svg';

const PageLinks = ({leftLink, rightLink}) => (
  <section className="page-links">
    <div className="page-links__inner">
      <div className="page-links__item page-links__left">
        <Link to={leftLink.url}>
          <img src={LeftArrow} alt={leftLink.title}/>
          <span>{leftLink.title}</span>
        </Link>
      </div>

      <div className="page-links__item page-links__right">
        <Link to={rightLink.url}>
          <span>{rightLink.title}</span>
          <img src={RightArrow} alt={rightLink.title}/>
        </Link>
      </div>
    </div>
  </section>
);

PageLinks.defaultProps = {
  leftLink: {
    title: 'Our Projects',
    url: '/projects/',
  },
  rightLink: {
    title: 'Get in touch',
    url: '/contact/',
  },
};

export default PageLinks;